<template>
<EditWorkFlow />
</template>

<script>
import EditWorkFlow from '@/components/3pl/Settings/Approval/EditWorkFlow/index'
export default {
components:{
    EditWorkFlow
}
}
</script>

<style>

</style>